import axios from "@/utils/axios";
import { toast } from "vue3-toastify";
import {
  getLignesCommandeDataByCommandeId,
  deleteCommandLine,
} from "@/services/devisService";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getFacturesData = async () => {
  try {
    const response = await axios.get(`${API_URL}/factures`);
    return response?.data?.data ?? [];
  } catch (error) {
    console.error(error);
    const message = error?.response?.data?.message || error?.message || "Une erreur est survenue";
    toast.error(message);
    return [];
  }
};

export const createFacture = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/factures`, data);
    return response.data.data;
  } catch (error) {
    console.error(error);
    const message = error?.response?.data?.message || "Une erreur est survenue";
    toast.error(message);
    return null;
  }
};

export const updateFacture = async (id, data) => {
  // Accept either plain object or FormData with file uploads
  if (data instanceof FormData) {
    if (!data.has("_method")) {
      data.append("_method", "PUT");
    }
    const response = await axios.post(`${API_URL}/factures/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.data;
  }
  const response = await axios.put(`${API_URL}/factures/${id}`, data);
  return response.data.data;
};

export const updateFactureDeclare = async (id, declare = true) => {
  const response = await axios.patch(`${API_URL}/factures/${id}/declare`, { declare });
  return response.data.data;
};

export const deleteFacture = async (id_facture, id_devis, id_commande) => {
  // Always try to delete the facture first (it depends on commande via FK)
  await axios.delete(`${API_URL}/factures/${id_facture}`);

  // Delete lines before deleting the commande
  let lines = [];
  try {
    lines = await getLignesCommandeDataByCommandeId(id_commande);
  } catch (_) {
    lines = [];
  }
  for (const m of lines) {
    try { await deleteCommandLine(m.id, m.commande_id ?? id_commande); } catch (_) { /* ignore missing line */ }
  }

  // Delete devis only if provided
  if (id_devis) {
    try { await axios.delete(`${API_URL}/devis/${id_devis}`); } catch (_) { /* ignore if devis not found */ }
  }

  // Finally delete the commande (ignore if already deleted/not found)
  if (id_commande) {
    try {
      const response = await axios.delete(`${API_URL}/commandes/${id_commande}`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return { success: true, message: "Commande déjà supprimée." };
      }
      throw error;
    }
  }
  return { success: true };
};
